import { enumIWizDataSet } from "../constants";
import { ApplyChartTemplateToBoxes } from "./ApplyChartTemplateToBoxes";
import { GetExtension } from "./GetExtension";

export function ApplyChartTemplateToDoc(targetDoc, theTemplate, boxList, applyToSubCharts, wsMgr) {
  if (!theTemplate) theTemplate = targetDoc.GetActiveTemplate();

  var boxStyleMgr = wsMgr.GetBoxStylesMgr();

  if (!theTemplate || !boxStyleMgr) return;
  var boxesResult = ApplyChartTemplateToBoxes(
    targetDoc,
    theTemplate,
    boxList,
    applyToSubCharts,
    wsMgr,
    boxStyleMgr
  );

  var doRecalc = boxesResult["doRecalc"];

  if (doRecalc) {
    //This breaks with autoformatting! Need to call the subchart switch later on.
    var scm = wsMgr.GetSubChartMgr();
    //var cSubchart = scm.GetCurrentSubChart();
    //wsMgr.SwitchToSubChart(cSubchart);

    var parentList = scm.GetParentListForChart();
    var sortConfig = targetDoc.GetLastSort();
    if (sortConfig != null) targetDoc.PerformSort(sortConfig, parentList);
    wsMgr.RecalcChartLayout();
  }

  if (theTemplate.GetTemplateID() == "__internalDynHighlight__") return;

  var iWizData = targetDoc.GetIWizData();
  var masterName = boxesResult["applyMaster"]; //Background name may not have been saved with an extension
  let backgroundMgr = wsMgr.fBackgroundMgr;
  let curBackgroundName = backgroundMgr.GetCurBackgroundName();
  if (masterName && !GetExtension(masterName)) masterName += ".oc5m";

  if (masterName !== false && curBackgroundName !== masterName) {
    backgroundMgr.BustMasterCache(backgroundMgr.GetCurBackgroundName());
    backgroundMgr.SetIsViewAppliedBackground(true);
    backgroundMgr.SetCurBackgroundName(masterName);
    wsMgr.ApplyBackground(enumIWizDataSet.refresh);
  } else if (masterName == false && wsMgr.fCanvasPanel && backgroundMgr.IsViewAppliedBackground()) {
    backgroundMgr.SetCurBackgroundName(iWizData.GetMasterFile());
    backgroundMgr.SetIsViewAppliedBackground(false);
    backgroundMgr.ClearActiveBackground();
  }
  targetDoc.UpdateDocContext();
}
